




































import { defineComponent, watch } from '@nuxtjs/composition-api';
import { lockPageScrollOnMobileOnly } from '@shared/composables/useUiHelpers/lockPageScroll';
import { unlockPageScrollOnMobileOnly } from '@shared/composables/useUiHelpers/unlockPageScroll';
import useVehiclesSidebar from '@shared/composables/useVehiclesSidebar';
import { VehicleSidebarState } from '@shared/system-constants';
import { BaseSidebar, UCIcon } from '@shared/ui';

import VehiclesGarage from '~/components/VehiclesSideBar/VehiclesGarage/VehiclesGarage.vue';
import VehiclesManualSearch from '~/components/VehiclesSideBar/VehiclesManualSearch/VehiclesManualSearch.vue';
import VehiclesRegoSearch from '~/components/VehiclesSideBar/VehiclesRegoSearch/VehiclesRegoSearch.vue';
import VehiclesVINSearch from '~/components/VehiclesSideBar/VehiclesVINSearch/VehiclesVINSearch.vue';

export default defineComponent({
  name: 'VehiclesSidebar',
  components: {
    VehiclesManualSearch,
    VehiclesRegoSearch,
    VehiclesGarage,
    VehiclesVINSearch,
    BaseSidebar,
    UCIcon,
  },
  setup() {
    const { state, close } = useVehiclesSidebar();

    watch(state, (state) => {
      if (state !== VehicleSidebarState.CLOSED) {
        lockPageScrollOnMobileOnly();
      } else {
        unlockPageScrollOnMobileOnly();
      }
    });

    return {
      state,
      close,
      VehicleSidebarState,
    };
  },
});
